export const converObjectErrorInString = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errorResponse: any,
): string | undefined => {
  try {
    if (typeof errorResponse === 'string') {
      return errorResponse
    }

    if (Array.isArray(errorResponse)) {
      for (const item of errorResponse) {
        const result = converObjectErrorInString(item)
        if (result) return result
      }
    }

    if (typeof errorResponse === 'object' && errorResponse !== null) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const asAny = errorResponse as any
      if (asAny && asAny?.message !== undefined) {
        const msg = asAny?.message
        if (typeof msg === 'string') return msg
        if (Array.isArray(msg) && msg.length) {
          const result = converObjectErrorInString(msg[0])
          if (result) return result
        }
      }
      for (const key in errorResponse) {
        const result = converObjectErrorInString(errorResponse[key])
        if (result) return result
      }
    }

    return undefined
  } catch (error) {
    return undefined
  }
}
